<div class="membership-card"
     [class.plan-basic]="colorClass === 'basic'"
     [class.plan-premium]="colorClass === 'premium'"
     [class.plan-platinum]="colorClass === 'platinum'">
  
  <!-- Popular Badge - Positioned at top right of card -->
  <span class="popular-badge" *ngIf="showPopularBadge">Popular</span>
  
  <!-- Plan Header -->
  <div class="plan-header">
    <div class="plan-header-content">
      <div class="plan-name-price-wrapper">
        <h3 class="plan-name"
            [style.color]="getHeadingColor()"
            [style.font-family]="getHeadingFont()">
          {{ planName }}
        </h3>
        <div class="plan-price-wrapper">
          <span class="plan-price-amount"
                [style.color]="getHeadingColor()"
                [style.font-family]="getHeadingFont()">
            {{ getPriceAmount() }}
          </span>
          <span class="plan-price-period"
                *ngIf="hasPricePeriod()"
                [style.color]="'#717683'"
                [style.font-family]="getHeadingFont()">
            {{ getPricePeriod() }}
          </span>
        </div>
      </div>
      <div class="plan-description-button-wrapper">
        <p class="plan-description"
           [style.color]="getParagraphColor()"
           [style.font-family]="getBodyFont()">
          {{ planDescription }}
        </p>
        <button class="purchase-button"
                [class.outlined]="colorClass !== 'platinum'"
                [class.filled]="colorClass === 'platinum'"
                [style.border-color]="getPrimaryColor()"
                [style.color]="colorClass === 'platinum' ? '#FFFFFF' : getPrimaryColor()"
                [style.background-color]="colorClass === 'platinum' ? getPrimaryColor() : 'transparent'"
                (click)="onBuyNowClick($event)">
          {{ buttonLabel }}
        </button>
      </div>
    </div>
  </div>

  <!-- Plan Features -->
  <div class="plan-features">
    <h4 class="features-title"
        [style.color]="getHeadingColor()"
        [style.font-family]="getHeadingFont()">
      {{ featuresTitle }}
    </h4>
    <ul class="features-list">
      <li class="feature-item" *ngFor="let feature of features; trackBy: trackByString">
        <svg class="check-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="#079271" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="feature-text"
              [style.color]="getParagraphColor()"
              [style.font-family]="getBodyFont()">
          {{ feature }}
        </span>
      </li>
    </ul>
  </div>
</div>

